/* eslint-disable */
import createIcon from '../createIcon';

const IconPlusOutlined = createIcon({
  name: 'icon-plus-outlined',
  content: '<path d="M830.287 544.816H193.075v-63.72h637.212z"/><path d="M544.18 194.35v637.212h-63.722V194.35z"/>',
  width: 1024,
  height: 1024
});
export default IconPlusOutlined;
